import { z } from 'zod';
import { RELATIONSHIP_OPTIONS } from '../types/authorisedContacts.types';
import { looksLikeCardNumber } from '../utils/looksLikeCardNumber';

export const NAME_MAX_LENGTH = 255;
export const RELATIONSHIP_MAX_LENGTH = 100;

export const authorisedContactSchema = z
    .object({
        name: z
            .string()
            .trim()
            .min(1, 'Enter the contact name')
            .max(NAME_MAX_LENGTH, `Name cannot exceed ${NAME_MAX_LENGTH} characters`)
            .refine((value) => !looksLikeCardNumber(value), 'The contact name must not contain a card number'),
        relationship: z.enum(RELATIONSHIP_OPTIONS, { message: 'Choose the relationship to the plan holder' }),
        relationshipOther: z
            .string()
            .trim()
            .max(RELATIONSHIP_MAX_LENGTH, `Relationship cannot exceed ${RELATIONSHIP_MAX_LENGTH} characters`)
            .refine((value) => !looksLikeCardNumber(value), 'The relationship must not contain a card number')
            .optional(),
    })
    .refine((values) => values.relationship !== 'other' || !!values.relationshipOther, {
        path: ['relationshipOther'],
        message: 'Describe the relationship',
    });

export type AuthorisedContactFormInput = z.input<typeof authorisedContactSchema>;
export type AuthorisedContactFormValues = z.output<typeof authorisedContactSchema>;

/** The wire value: the free text when 'Other' was chosen, else the option's label. */
export const toRelationshipValue = (values: AuthorisedContactFormValues): string =>
    values.relationship === 'other' ? (values.relationshipOther ?? '') : values.relationship;
